// We added this schema manually as there is currently no schema that would generate values for the Drone product
import * as z from 'zod'

import { BaseSchema_LiabilityV1GetsafeDe } from '@flows/insurance/schemas/Schema_LiabilityV1GetsafeDe'

export const BaseSchema_Drone = z
  .object({
    weight_is_too_high: z.enum(['no', 'yes']).optional(),
    number_of_drones: z.enum(['1', '2-5', 'more_than_five']).optional(),
  })
  .merge(
    BaseSchema_LiabilityV1GetsafeDe.pick({
      cancelled_by_previous_insurer: true,
      deductible_amount: true,
      drones_coverage: true,
      family_coverage: true,
      number_of_claims_in_last_5y: true,
      previous_insurance_in_last_5y: true,
      tariff_line: true,
      zip_code: true,
    })
  )
